import { defineStore } from "pinia";
// import userData from '../views/GoogleLogin.vue'

export const useSearchStore = defineStore("search", {
    state: () => ({
        search: null,
    }),

    actions: {
        setSearch(search) {
            return this.search = search
        },
        getSearch() {
            return this.search
        }
    }
})